// extracted by mini-css-extract-plugin
module.exports = {"container":"specification-module__container___YzwJ2","item":"specification-module__item___QOtmm"};